import { PagesDocuments } from '@web-kc/pages/documents';
import { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

export default PagesDocuments;

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  defaultLocale = 'ru',
}) => {
  return {
    props: {
      ...(await serverSideTranslations(locale ?? defaultLocale, [
        'common',
        'documents',
      ])),
    },
  };
};
